import React, { useEffect } from 'react';

const LoaderModal = ({ isVisible, title, packageName }) => {
  if (!isVisible) return null;

  return (
    <div className="fixed inset-0 flex items-center justify-center z-50">
      <div className="bg-black/50 backdrop-blur-sm absolute inset-0"></div>
      
      <div className="bg-white rounded-lg p-6 relative z-10 w-[300px] shadow-xl">
        {/* Smaller Spinner Animation */}
        <div className="flex justify-center mb-4">
          <div className="animate-spin rounded-full h-10 w-10 border-t-2 border-b-2 border-[#EA011F]"></div>
        </div>

        {/* Package Info */}
        <div className="text-center space-y-2">
          <span className="text-[#EA011F] font-medium text-xs bg-red-50 px-3 py-1 rounded-full">
            {title || 'Switching to'}
          </span>
          
          {packageName && (
            <h3 className="text-base font-bold text-gray-800">
              {packageName}
            </h3>
          )}
          
          {/* Improved text styling */}
          <p className="text-sm font-regular text-gray-600 mt-2 leading-relaxed tracking-wide font-normal max-w-[250px] mx-auto">
            Please wait, while we process your request
          </p>
        </div>
      </div>
    </div>
  );
}

export default LoaderModal;
